import { createContext } from "react";
import { AppContextInterface } from "./app.interface";

export const AppContext = createContext<AppContextInterface>({
    setSession: () => {},
});